import * as React from 'react'
import { cn } from '@/lib/utils'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

/**
 * Wire errors with `aria-invalid` and `aria-describedby` (or use <FormField>, which does it for you).
 */
const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        'flex h-control w-full rounded-md border border-border-strong bg-surface px-3 text-base text-text',
        'file:border-0 file:bg-transparent file:text-base file:font-medium',
        'placeholder:text-text-muted hover:border-text-secondary',
        'focus-visible:border-primary focus-visible:outline-none focus-visible:shadow-focus',
        'aria-[invalid=true]:border-error',
        'read-only:border-border read-only:bg-surface-sunken',
        'disabled:cursor-not-allowed disabled:border-border disabled:bg-surface-sunken disabled:text-text-disabled',
        className,
      )}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = 'Input'

export { Input }
